import React from 'react';
import { Translate } from '@above-the-treeline/localization';

function NoMatchesFoundMessage() {
	return (
		<p className="no-matches-found-message">
			<Translate id="no_matches_found_no_punctuation" />
		</p>
	);
}

export default NoMatchesFoundMessage;
